/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 09:25:33
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-04-10, 13:58:53
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import PropTypes from 'prop-types';
import { LocaleProvider } from 'antd';
//import OfflinePlatform from 'routes/offline';
import plPL from 'antd/lib/locale-provider/pl_PL';
//import { Offline, Online } from 'react-detect-offline';

const App = props => 
  (<LocaleProvider locale={plPL}>
    <div>
      {props.children}
    </div>
  </LocaleProvider>)

App.propTypes = {
  children: PropTypes.any.isRequired
}

export default App;



// WEBPACK FOOTER //
// ./src/rcapp/routes/app/index.js